document.addEventListener('DOMContentLoaded', function () {
  // Esconde qualquer botão flutuante ([data-panda-floating-widget], ex.:
  // WhatsApp e "descobrir tamanho") enquanto o carrinho ou o menu mobile
  // estiverem abertos — os dois abrem do lado direito da tela, na mesma
  // área onde esses botões ficam fixos, e sem isso eles boiavam por cima
  // do painel (drawer) aberto.
  var drawers = [
    document.getElementById('panda-cart-drawer'),
    document.getElementById('panda-mobile-drawer'),
  ].filter(Boolean);
  var widgets = Array.prototype.slice.call(document.querySelectorAll('[data-panda-floating-widget]'));
  if (!drawers.length || !widgets.length) return;

  function update() {
    var anyOpen = drawers.some(function (el) {
      return el.classList.contains('open');
    });
    widgets.forEach(function (w) {
      w.classList.toggle('panda-floating-obscured', anyOpen);
    });
  }

  drawers.forEach(function (el) {
    new MutationObserver(update).observe(el, { attributes: true, attributeFilter: ['class'] });
  });

  update();
});
